export * from './browser/index';

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
